<span class="sb-dt-sentinel" tabindex="0" aria-hidden="true" (focus)="onSentinelFocus('back')"></span>
<div class="sb-dt-panel__body" (pointerdown)="onPointerDown()">
  <div class="sb-dt-panel__content">
  @if (picks().length) {
  <div class="sb-dt-picks">
    <div class="sb-dt-picks__list" role="group" [attr.aria-label]="picksName()">
    @for (view of picks(); track view.id; let i = $index) {
    <button
      #pickButton
      type="button"
      class="dropdown-item sb-dt-pick"
      [class.sb-dt-pick--disabled]="!!view.reason"
      [attr.tabindex]="i === activePick() ? 0 : -1"
      [attr.aria-disabled]="view.reason ? 'true' : null"
      [matTooltip]="view.reason ? 'Unavailable: ' + view.reason : ''"
      (focus)="activePick.set(i)"
      (keydown)="onPickKeydown($event, i)"
      (click)="choosePick(view)">
      @let parts = pickParts(view.value);
      <span class="sb-dt-pick__text">{{ view.label }}@if (view.value) {: <span class="sb-dt-pick__value">{{ parts[0] }}@if (parts[1]) {<span class="sb-dt-pick__time">{{ parts[1] }}</span>}{{ parts[2] }}</span>}</span>
    </button>
    }
    </div>
  </div>
  }

  <div class="sb-dt-panel__main">
  @if (hasCalendar()) {
  <div class="sb-dt-panel__calendar">
    <mat-calendar
      [selected]="calendarSelected()"
      [startAt]="startAt()"
      [minDate]="minDate()"
      [maxDate]="maxDate()"
      startDateAccessibleName="Start date"
      endDateAccessibleName="End date"
      (selectedChange)="onCalendarChange($event)">
    </mat-calendar>
  </div>
  }

  @if (hasTime()) {
  <div class="sb-dt-time" role="group" aria-label="Time">
    <div class="sb-dt-time__columns">
      <div class="sb-dt-time__col">
        <div class="sb-dt-time__head" aria-hidden="true">Hour</div>
        <ul
          #hourList
          #column
          class="sb-dt-time__column"
          cdkListbox
          aria-label="Hour"
          [cdkListboxValue]="hour12() === null ? [] : [hour12()]"
          (cdkListboxValueChange)="onHour($event)">
          @for (hour of hours; track hour) {
          <li #hourOption class="sb-dt-time__option" [cdkOption]="hour">{{ hour }}</li>
          }
        </ul>
      </div>
      <div class="sb-dt-time__col">
        <div class="sb-dt-time__head" aria-hidden="true">Min</div>
        <ul
          #column
          class="sb-dt-time__column"
          cdkListbox
          aria-label="Minute"
          [cdkListboxValue]="minuteValue()"
          (cdkListboxValueChange)="onMinute($event)">
          @for (value of minutes; track value) {
          <li class="sb-dt-time__option" [cdkOption]="value">{{ pad(value) }}</li>
          }
        </ul>
      </div>
      <div class="sb-dt-time__col">
        <div class="sb-dt-time__head" aria-hidden="true">&nbsp;</div>
        <ul
          #column
          class="sb-dt-time__column sb-dt-time__column--period"
          cdkListbox
          aria-label="AM or PM"
          [cdkListboxValue]="period() === null ? [] : [period()]"
          (cdkListboxValueChange)="onPeriod($event)">
          @for (value of periods; track value) {
          <li class="sb-dt-time__option" [cdkOption]="value">{{ value }}</li>
          }
        </ul>
      </div>
    </div>
  </div>
  }
  </div>
  </div>
</div>

@if (status() || zoneNote()) {
<div class="sb-dt-panel__zone">{{ status() || zoneNote() }}</div>
}

@if (showClear() || showToday() || hasTime()) {
<div class="sb-dt-panel__footer">
  @if (showClear()) {
  <app-sb-button variant="link" size="sm" label="Clear" (clicked)="cleared.emit()"></app-sb-button>
  }
  <span class="sb-dt-panel__footer-end">
    @if (showToday()) {
    <app-sb-button
      variant="link"
      size="sm"
      [label]="todayLabel()"
      [disabled]="!!todayReason()"
      [ariaLabel]="todayReason() ? todayLabel() + ', ' + todayReason() : ''"
      (clicked)="todayChosen.emit()"></app-sb-button>
    }
    @if (hasTime()) {
    <app-sb-button variant="link" size="sm" label="Done" (clicked)="done.emit()"></app-sb-button>
    }
  </span>
</div>
}
<span class="sb-dt-sentinel" tabindex="0" aria-hidden="true" (focus)="onSentinelFocus('forward')"></span>
